import {configureStore} from '@reduxjs/toolkit';
//reducer
import organizationStore from './organization/reducer';
import organizationEventStore from './organization-event/reducer';
import organizationDashboardStore from './organization-dashboard/reducer';
import organizationTablesAndTicketsStore from './organization-tables/reducer';
import organizationAuctionStore from './organization-auction/reducer';
import organizationAttendeesStore from './organization-attendees/reducer';
import organizationNotificationStore from './organization-notificationSetting/reducer';
import notificationStore from './notification/reducer';
import userStore from './user/reducer';
import userNotificationStore from './user-notificationSetting/reducer';
import userDonationStore from './user-donation/reducer';
import organizationTeamStore from './orgatization-team/reducer';
import superAdminStore from './admin/reducer';
import organizationReportStore from './organization-report/reducer';
import adminNotificationStore from './admin-notificationSettings/reducer';
import organizationCommunicationStore from './organization-communication/reducer';
import organizationAttendeesContributionsStore from './organization-attendeeContribution/reducer';
import userRaffleStore from './raffle/reducer';
import organizationBillingStore from './organization-billingHistory/reducer';

const store = configureStore({
	reducer: {
		organizationStore,
		organizationEventStore,
		organizationDashboardStore,
		organizationTablesAndTicketsStore,
		organizationAuctionStore,
		organizationAttendeesStore,
		organizationNotificationStore,
		organizationTeamStore,
		notificationStore,
		userStore,
		userNotificationStore,
		userDonationStore,
		superAdminStore,
		organizationReportStore,
		adminNotificationStore,
		organizationCommunicationStore,
		organizationAttendeesContributionsStore,
		userRaffleStore,
		organizationBillingStore,

	},
});

// Global store type
export type StoreType = ReturnType<typeof store.getState>;

// Dispatch type
export type DispatchType = typeof store.dispatch;

export default store;
